export enum BookingStatus {
  PENDING = 'pending',
  CANCELLED = 'cancelled',
  CANCELLED_NOT_PAID = 'cancelled_not_paid',
  CANCELLED_USER = 'cancelled_user',
  CANCELLED_VENDOR = 'cancelled_vendor',
  CANCELLED_PAYMENT_CHALLENGE = 'cancelled_payment_challenge',
  CONFIRMED = 'confirmed',
  WAITLISTED = 'waitlisted',
  CHECKED_IN = 'checked_in',
  PENDING_PAYMENT = 'pending_payment',
  BOOKED = 'Booked',
  WAITLIST = 'waitlist',
  WAITLIST_WAITING_FOR_CONFIRMATION = 'waiting_for_confirmation',
  WAITLIST_CANCELLED_NOT_CONFIRMED = 'cancelled_not_confirmed',
}

export enum PATCH_STATUSES {
  CANCELLED = 'cancelled',
  CHECKED_IN = 'checked_in',
  CONFIRMED = 'confirmed',
  WAITLIST = 'waitlist',
}
